// import Swiper JS
// import Swiper styles
//import 'swiper/swiper.min.css';
import Swiper, { Autoplay } from 'swiper';

// only run code when the section is on the page
if ($('.s-slider-swiper').length !== 0) {
    Swiper.use([Autoplay]);

    // list of available setting parameters https://swiperjs.com/swiper-api#parameters
    const swiperOptions = {
        // direction: 'vertical',
        loop: true,
        loopedSlides: 50,
        grabCursor: true,
        autoplay: {
            delay: 0, // delay after each come to view before moving to the next one
            disableOnInteraction: false,
        },
        // configuration of lazy loading of images
        lazy: {
            checkInView: true,
            elementClass: 'c-image__img',
            loadOnTransitionStart: true,
            loadPrevNext: true,
        },
        speed: 3000,
        // freeModeMomentum: false,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1.2,
                spaceBetween: 15,
                freeMode: true,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 1.5,
                spaceBetween: 15,
                freeMode: true,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 2.2,
                spaceBetween: 15,
                freeMode: true,
            },
            // when window width is >= 1024px
            1024: {
                slidesPerView: 3.2,
                spaceBetween: 15,
                freeMode: false,
            },
            // when window width is >= 1440px
            1440: {
                slidesPerView: 4.5,
                spaceBetween: 15,
                freeMode: false,
            },
        },
    };
    /* eslint-disable */
    const swiper = new Swiper('.s-slider-swiper__container', swiperOptions);
    /* eslint-enable */

    /**
     * Load images when the section becomes visible
     * It fixes an issue with images that come into the viewport not appearing in Safari
     */
    // run this function imminently
    (function () {
        const options = {
            root: null, // use the document's viewport as the container
            rootMargin: '50px', // % or px - offsets added to each side of the intersection, it delays the intersection event by set distance
            threshold: 0, // percentage of the target element which is visible
        };

        // Callback docs: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Targeting_an_element_to_be_observed
        const callback = (entries) => {
            entries.forEach((element) => {
                // If selector entry is visible in the viewport - according to the params set in `options`
                if (element.isIntersecting) {
                    const sliderImages = element.target.querySelectorAll('img');

                    sliderImages.forEach((slideImage) => {
                        const dataSrc = slideImage.dataset.src;

                        // replace the URL of the lazy load placeholder with the URL of the slide image
                        if (dataSrc) {
                            slideImage.src = dataSrc;
                        }
                    });

                    // stop observing sliders that were already visible to save memory
                    observer.unobserve(element.target);
                }
            });
        };

        // Create the intersection observer instance that is added to each element below
        const observer = new IntersectionObserver(callback, options);

        // get all swiper sliders
        const sliders = document.querySelectorAll('.s-slider-swiper');

        // When document is ready, get all selectors from DOM and attach the observer to these
        sliders.forEach((slider) => {
            observer.observe(slider);
        });
    })();
}



// WEBPACK FOOTER //
// ./scripts/routes/sections/slider-swiper.js